import { initSentry } from './lib/sentry';

// Initialize Sentry BEFORE any other imports/rendering
initSentry();

import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './lib/i18n'
import { ThemeProvider } from "@/components/providers/ThemeProvider";
import { bootstrapAIPlatform } from './lib/ai/bootstrap';

// Register production AI providers (OpenAI) before the first render.
bootstrapAIPlatform();

createRoot(document.getElementById("root")!).render(
  <ThemeProvider
    attribute="class"
    defaultTheme="system"
    enableSystem
    disableTransitionOnChange
  >
    <App />
  </ThemeProvider>
);
